// Kind → icon map for the move-with-automation modal. Local copy of the
// interview-plan automation drawer's KIND_ICONS so this shared component
// doesn't reach into `src/pages/...` and trip the layering rule.
//
// Keep in sync with:
//   src/pages/ats-job-creation/tabs/interview-plan/stage/automation/activityIcons.ts
// When the icon system gets a proper home in a shared layer, both
// should consume the same source.
import type { ElementType } from 'react';
import { File02 } from '@kula-ai/icons/dual-tone/File02';
import {
  Assessment,
  Mail,
  Review,
  SheduleInterview,
  SurveyV2,
} from '@/assets/icons/interview-plan';
import {
  Hackerrank,
  Hackerearth,
  CriteriaCorp,
  CodeInterview,
  Hireflix,
} from '@/assets/icons/ats';

const KIND_ICONS: Record<string, ElementType> = {
  interview: SheduleInterview,
  email: Mail,
  review: Review,
  assessment: Assessment,
  survey: SurveyV2,
  hackerrank: Hackerrank,
  hackerrank_interview: Hackerrank,
  hackerearth_assessment: Hackerearth,
  criteriacorp_assessment: CriteriaCorp,
  codeinterview_assessment: CodeInterview,
  hireflix_assessment: Hireflix,
};

export const getActivityKindIcon = (kind: string | undefined): ElementType =>
  (kind && KIND_ICONS[kind]) || File02;
